import type {
    RequestBodyKeyEnum,
    RequestFileKeyEnum,
} from '@/Shared/AutoGenerated/RequestFieldEnum'

export default class ApiFormErrors {
    constructor(private readonly errors: any) {}

    getValidationError(
        key: RequestBodyKeyEnum | RequestFileKeyEnum,
    ): string | undefined {
        return this.getValidationErrorUsingRawString(key)
    }

    getValidationErrorUsingRawString(key: string): string | undefined {
        if (typeof this.errors !== 'object') {
            throw new Error('Errors must be an object')
        }

        return key in this.errors
            ? (this.errors[key][0] ?? undefined)
            : undefined
    }
}
